import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  LinearProgress,
  Typography,
} from '@mui/material';

import logo from '../../../assets/icons/KeyboardArrowDownIcon.svg';
import { limitFillRatioTo100Percent } from '../../../components/ShiftCard/helperFunctions';
import theme from '../../../theme';
import { BLACK, FEED_BACK } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';

const RosterBlock = ({ testId, title, rosterContent, fillRatio }) => (
  <Accordion
    defaultExpanded
    sx={{
      boxShadow: 'none',
      backgroundColor: BLACK[10],
      padding: '16px',
    }}
    data-testid={testId}
  >
    <AccordionSummary
      expandIcon={<img src={logo} alt="Expand icon" />}
      aria-controls="panel1-content"
      id="panel1-header"
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: 0,
        minHeight: 'unset',
        '&.Mui-expanded': {
          minHeight: 'unset',
        },
        '& .MuiAccordionSummary-content': {
          margin: 0,
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
          margin: 0,
        },
      }}
    >
      <Box display="flex" alignItems="center" flexGrow={1}>
        <Typography
          style={{
            fontFamily: PRIMARY_FONT[500],
            fontWeight: 'bold',
            marginRight: '10px',
            fontSize: '16px',
            textTransform: 'uppercase',
          }}
        >
          {title}
        </Typography>
        {typeof fillRatio === 'number' && (
          <Box sx={{ display: 'flex', alignItems: 'center', width: '120px', gap: '8px' }}>
            <Typography
              sx={{
                fontFamily: PRIMARY_FONT[300],
                fontSize: '16px',
                color: BLACK[100],
                lineHeight: '16px',
              }}
            >
              {`${limitFillRatioTo100Percent(fillRatio)}%`}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={limitFillRatioTo100Percent(fillRatio)}
              sx={{
                width: '73px',
                height: '7px',
                borderRadius: '16px',
                backgroundColor: 'transparent',
                border: `1px solid ${BLACK[100]}`,
                '& .MuiLinearProgress-bar': {
                  borderRadius: '16px',
                  backgroundColor: FEED_BACK.GREEN_70,
                },
              }}
            />
          </Box>
        )}
      </Box>
      <Typography
        sx={{
          fontFamily: PRIMARY_FONT[400],
          alignSelf: 'center',
          fontSize: '14px',
          textTransform: 'uppercase',
          marginRight: '12px',
        }}
      >
        {LanguageConverter('button.close')}
      </Typography>
    </AccordionSummary>
    <AccordionDetails
      sx={{
        background: BLACK[10],
        padding: theme.spacing(3, 0, 0, 0),
      }}
    >
      <Box style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}> {rosterContent} </Box>
    </AccordionDetails>
  </Accordion>
);

RosterBlock.propTypes = {
  testId: PropTypes.string,
  title: PropTypes.string,
  rosterContent: PropTypes.node,
  fillRatio: PropTypes.number,
};

export default RosterBlock;
